import React from 'react';
import styles from './avatar.module.scss';
var Avatar = function (_a) {
    var name = _a.name, secondName = _a.secondName;
    var firstLetter = name.charAt(0) + secondName.charAt(0) || 'AD';
    return (React.createElement("div", { className: styles.avatar, style: { backgroundColor: 'green' } },
        React.createElement("span", { className: styles.letter }, firstLetter)));
};
export default Avatar;
